import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Custom hook to enable swipe-to-go-back gesture on mobile
 * Swipe from left edge to go back in navigation history
 */
export const useSwipeBack = (enabled = true) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only enable on mobile (Capacitor)
    if (!window.Capacitor || !enabled) return;

    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    let isSwiping = false;

    const handleTouchStart = (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      
      // Only start tracking if touch starts near left edge (within 50px)
      if (touchStartX < 50) {
        isSwiping = true;
      }
    };

    const handleTouchMove = (e) => {
      if (!isSwiping) return;
      
      touchEndX = e.touches[0].clientX;
      touchEndY = e.touches[0].clientY;
    };

    const handleTouchEnd = () => {
      if (!isSwiping) {
        return;
      }

      isSwiping = false;

      const deltaX = touchEndX - touchStartX;
      const deltaY = Math.abs(touchEndY - touchStartY);

      // Swipe right (back gesture)
      // Must swipe at least 100px horizontally
      // Vertical movement must be less than horizontal (not scrolling)
      if (deltaX > 100 && deltaY < 75) {
        // Go back in history
        navigate(-1);
      }
    };

    // Add event listeners
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });

    // Cleanup
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [navigate, location, enabled]);
};

export default useSwipeBack;

